import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal'

import { modalStyles } from './constants';
import { setSearchModalState } from 'actions/search';
import { FILTERS } from './constants';
import { getSearchValue, getSearchValueState, getRegions,
  getSubregions, getBuildings, getSearchModalState,
  getSearchRequestFetchStatus, getStreets } from 'selectors/search';
import SearchFullscreen from './SearchFullscreen';
import s from './style';

const mapStateToProps = (state) => ({
  searchValue: getSearchValue(state),
  isLoading: getSearchValueState(state),
  regions: getRegions(state),
  subregions: getSubregions(state),
  buildings: getBuildings(state),
  streets: getStreets(state),
  isSearchModalOpen: getSearchModalState(state),
  isFetched: getSearchRequestFetchStatus(state)
});

const mapDispatchToProps = {
  setSearchModalState
};

@connect(mapStateToProps, mapDispatchToProps)
class SearchFullscreenContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: FILTERS.ALL
    };
  }

  setFilter = (filter) => this.setState({ filter })
  closeModal = () => this.props.setSearchModalState(false);

  render() {
    const {
      isSearchModalOpen,
      ...other
    } = this.props;

    return (
      <ReactModal
        isOpen={isSearchModalOpen}
        contentLabel="Modal"
        style={modalStyles}
        className={s.SearchModal}
        overlayClassName={s.SearchModalOverlay}
        onRequestClose={this.closeModal}
      >
        <SearchFullscreen
          setFilter={this.setFilter}
          filter={this.state.filter}
          closeModal={this.closeModal}
          {...other}
        />
      </ReactModal>
    );
  }
}

export default SearchFullscreenContainer;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/SearchFullscreenContainer.js